import { render, staticRenderFns } from "./UpdateDiamond.vue?vue&type=template&id=40017f3b&scoped=true"
import script from "./UpdateDiamond.vue?vue&type=script&lang=js"
export * from "./UpdateDiamond.vue?vue&type=script&lang=js"
import style0 from "./UpdateDiamond.vue?vue&type=style&index=0&id=40017f3b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40017f3b",
  null
  
)

export default component.exports